enum CheckoutSection {
  shipping = 0,
  payment = 1,
  confirm = 2,
  thankYou = 3,
}

export default CheckoutSection;
